import {connect} from 'react-redux';
import LoginForm from '../../components/forms/LoginForm';
import {login} from '../../actions/authorizationAction';

const mapStateToProps = state => {
    return {
        error: state.authorization.error,
        loading: state.authorization.loading,
        roleError: state.authorization.roleError
    }
};

const mapDispatchToProps = dispatch => {
    return {
        onLoginSubmit: (username, password) => {
            dispatch(login(username, password))
        }
    }
};

const LoginFormContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginForm);

export default LoginFormContainer;